module.exports = __webpack_public_path__ + "img/intp.6d921967.png";